import { LAW } from "../constants";
import { asDate, isDateGte } from "./utils";

export const COL = {
  TODOUFUKEN: "都道府県",
  GUN: "郡",
  CITY: "市町村",
  EXCITY: "除外町村",
  RANK: "優先順位",
  OLD_CODE: "旧地域区分コード",
  OLD_NAME: "旧地域区分",
  CODE_H27: "平成27年度地域区分コード",
  NAME_H27: "平成27年度地域区分",
  CODE_CLD: "地域区分コード(障害児)",
  NAME_CLD: "地域区分(障害児)",
  CODE_CLD_H27: "平成27年度地域区分コード(障害児)",
  NAME_CLD_H27: "平成27年度地域区分(障害児)",
  CODE_CLD_H28: "平成28年度地域区分コード(障害児)",
  NAME_CLD_H28: "平成28年度地域区分(障害児)",
  CODE_KAIGO_H27: "平成27年度地域区分コード(介護保険)",
  NAME_KAIGO_H27: "平成27年度地域区分(介護保険)",
  CODE_H30: "平成30年度地域区分コード",
  NAME_H30: "平成30年度地域区分",
  CODE_CLD_H30: "平成30年度地域区分コード(障害児)",
  NAME_CLD_H30: "平成30年度地域区分(障害児)",
  CODE_KAIGO_H30: "平成30年度地域区分コード(介護保険)",
  NAME_KAIGO_H30: "平成30年度地域区分(介護保険)",
  CODE_R03: "令和3年度地域区分コード",
  NAME_R03: "令和3年度地域区分",
  CODE_CLD_R03: "令和3年度地域区分コード(障害児)",
  NAME_CLD_R03: "令和3年度地域区分(障害児)",
  CODE_KAIGO_R03: "令和3年度地域区分コード(介護保険)",
  NAME_KAIGO_R03: "令和3年度地域区分(介護保険)",
  CODE_R06: "令和6年度地域区分コード",
  NAME_R06: "令和6年度地域区分",
  CODE_CLD_R06: "令和6年度地域区分コード(障害児)",
  NAME_CLD_R06: "令和6年度地域区分(障害児)",
  CODE_KAIGO_R06: "令和6年度地域区分コード(介護保険)",
  NAME_KAIGO_R06: "令和6年度地域区分(介護保険)",
};

const COLUMN_RULES = {
  jidou: [
    { since: "2024-04-01", code: COL.CODE_CLD_R06, name: COL.NAME_CLD_R06 },
    { since: "2021-04-01", code: COL.CODE_CLD_R03, name: COL.NAME_CLD_R03 },
    { since: "2018-04-01", code: COL.CODE_CLD_H30, name: COL.NAME_CLD_H30 },
    { since: "2016-04-01", code: COL.CODE_CLD_H28, name: COL.NAME_CLD_H28 },
    { since: "2015-04-01", code: COL.CODE_CLD_H27, name: COL.NAME_CLD_H27 },
    { since: null, code: COL.CODE_CLD, name: COL.NAME_CLD },
  ],
  shougai: [
    { since: "2024-04-01", code: COL.CODE_R06, name: COL.NAME_R06 },
    { since: "2021-04-01", code: COL.CODE_R03, name: COL.NAME_R03 },
    { since: "2018-04-01", code: COL.CODE_H30, name: COL.NAME_H30 },
    { since: "2015-04-01", code: COL.CODE_H27, name: COL.NAME_H27 },
    { since: null, code: COL.OLD_CODE, name: COL.OLD_NAME },
  ],
  kaigo: [
    { since: "2024-04-01", code: COL.CODE_KAIGO_R06, name: COL.NAME_KAIGO_R06 },
    { since: "2021-04-01", code: COL.CODE_KAIGO_R03, name: COL.NAME_KAIGO_R03 },
    { since: "2018-04-01", code: COL.CODE_KAIGO_H30, name: COL.NAME_KAIGO_H30 },
    { since: "2015-04-01", code: COL.CODE_KAIGO_H27, name: COL.NAME_KAIGO_H27 },
  ],
};

function isLengthK(date) {
  const target = asDate(date);
  return target && asDate("2012-04-01") <= target && target < asDate("2015-04-01");
}

export function isKeikaDate(date) {
  const target = asDate(date);
  return target && asDate("2012-04-01") <= target && target <= asDate("2015-03-31");
}

function isShougai(law, keikasochi = false) {
  return law === LAW.SHOUGAI && keikasochi === false;
}

function isJidou(law, keikasochi = false) {
  return law === LAW.JIDOU && keikasochi === false;
}

function pickColumns(rules, date) {
  for (const rule of rules) {
    if (rule.since === null || isDateGte(date, rule.since)) {
      return [rule.code, rule.name];
    }
  }
  return [null, null];
}

export function resolveColumns(law, date, keikasochi = false) {
  if (isJidou(law, keikasochi)) {
    return pickColumns(COLUMN_RULES.jidou, date);
  }

  if (isShougai(law, false) && keikasochi && isLengthK(date)) {
    return [COL.OLD_CODE, COL.OLD_NAME];
  }

  if (isShougai(law, keikasochi)) {
    return pickColumns(COLUMN_RULES.shougai, date);
  }

  if (law === LAW.KAIGO) {
    return pickColumns(COLUMN_RULES.kaigo, date);
  }

  return [null, null];
}
